<kendo-expansionpanel [title]="'Order ' + getOrderNumber()"
                      [subtitle]="''"
                      [expanded]="true">
    <div class="row" *ngIf="(crossBorderLoad | json) != '{}'">
        <div class="col-sm-12">
            <div class="row">
                <div class="col">
                    <div class="standard-card">
                        <div class="row">
                            <div class="col">
                                <h3>Bill To</h3>
                                <a target="_blank" [routerLink]="['/customer-detail', crossBorderLoad.billToCustomerCode]" tabindex="-1">{{crossBorderLoad.billToCustomerName}}</a><br />
                                <a target="_blank" [routerLink]="['/customer-detail', crossBorderLoad.billToCustomerCode]" tabindex="-1">{{crossBorderLoad.billToCustomerCode}}</a><br />
                                {{crossBorderLoad.billToAddress1}}<br />
                                {{crossBorderLoad.billToCity}}, {{crossBorderLoad.billToSTAbbr}}<br />
                                {{crossBorderLoad.billToCountry}}<br />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="standard-card">
                        <div class="row">
                            <div class="col">
                                <h3>Carrier</h3>
                                <a target="_blank" [routerLink]="['/carrier-detail', crossBorderLoad.carrierCode]" tabindex="-1">{{crossBorderLoad.carrierName}}</a><br />
                                <a target="_blank" [routerLink]="['/carrier-detail', crossBorderLoad.carrierCode]" tabindex="-1">{{crossBorderLoad.carrierCode}}</a><br />
                                {{crossBorderLoad.carrierAddress1}}<br />
                                {{crossBorderLoad.carrierCity}}, {{crossBorderLoad.carrierSTAbbr}}<br />
                                {{crossBorderLoad.carrierCountry}}<br />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="standard-card">
                        <div class="row">
                            <div class="col">
                                <h3>Load Shipper</h3>
                                <a target="_blank" [routerLink]="['/customer-detail', crossBorderLoad.shipperCustomerCode]" tabindex="-1">{{crossBorderLoad.shipperCustomerName}}</a><br />
                                <a target="_blank" [routerLink]="['/customer-detail', crossBorderLoad.shipperCustomerCode]" tabindex="-1">{{crossBorderLoad.shipperCustomerCode}}</a><br />
                                {{crossBorderLoad.shipperAddress1}}<br />
                                {{crossBorderLoad.shipperCity}}, {{crossBorderLoad.shipperSTAbbr}}<br />
                                {{crossBorderLoad.shipperCountry}}<br />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="standard-card">
                        <div class="row">
                            <div class="col">
                                <h3>Load Consignee</h3>
                                <a target="_blank" [routerLink]="['/customer-detail', crossBorderLoad.consigneeCustomerCode]" tabindex="-1">{{crossBorderLoad.consigneeCustomerName}}</a><br />
                                <a target="_blank" [routerLink]="['/customer-detail', crossBorderLoad.consigneeCustomerCode]" tabindex="-1">{{crossBorderLoad.consigneeCustomerCode}}</a><br />
                                {{crossBorderLoad.consigneeAddress1}}<br />
                                {{crossBorderLoad.consigneeCity}}, {{crossBorderLoad.consigneeSTAbbr}}<br />
                                {{crossBorderLoad.consigneeCountry}}<br />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="row">
                        <div class="col">
                            <label class="fw-bold">Crossing Type</label>
                            <input type="text" class="form-control" [(ngModel)]="crossBorderLoad.legCntryToCntry" disabled />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <label class="fw-bold">Logistic Specialist</label>
                            <input type="text" class="form-control" [(ngModel)]="crossBorderLoad.logisticSpecialist" disabled />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <label class="fw-bold">Trailer #</label>
                            <input type="text" class="form-control" [(ngModel)]="crossBorderLoad.trailerNumber" disabled />
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="standard-card">
                        <div class="row">
                            <div class="col">
                                <h3>Carrier Sales Rep</h3>
                                {{crossBorderLoad.csrName}}<br />
                                Email: <a href="mailto:{{crossBorderLoad.csrEmail}}">{{crossBorderLoad.csrEmail}}</a><br />
                                Cell: <a href="tel:{{crossBorderLoad.csrCell}}" *ngIf="crossBorderLoad.csrCell != '' && crossBorderLoad.csrCell != null">{{crossBorderLoad.csrCell | phone:'US'}}</a><br />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label class="fw-bold">Pickup Date</label>
                    <kendo-datepicker name="pickupDate" [(ngModel)]="crossBorderLoad.pickupDate"
                                      [format]="'MM/dd/yy'" disabled>
                    </kendo-datepicker>
                    <br />
                    <kendo-datepicker name="pickupDate" [(ngModel)]="crossBorderLoad.pickupDate"
                                      [format]="'HH:mm'" disabled>
                    </kendo-datepicker>
                </div>
                <div class="col">
                    <label class="fw-bold">Crossing Date</label>
                    <kendo-datepicker name="crossingDate" [(ngModel)]="crossBorderLoad.crossingDate"
                                      [format]="'MM/dd/yy'" disabled>
                    </kendo-datepicker>
                    <br />
                    <kendo-datepicker name="crossingDate" [(ngModel)]="crossBorderLoad.crossingDate"
                                      [format]="'HH:mm'" disabled>
                    </kendo-datepicker>
                </div>
                <div class="col">
                    <label class="fw-bold">Delivery Date</label>
                    <kendo-datepicker name="deliveryDate" [(ngModel)]="crossBorderLoad.deliveryDate"
                                      [format]="'MM/dd/yy'" disabled>
                    </kendo-datepicker>
                    <br />
                    <kendo-datepicker name="deliveryDate" [(ngModel)]="crossBorderLoad.deliveryDate"
                                      [format]="'HH:mm'" disabled>
                    </kendo-datepicker>
                    <br />
                    <label class="fw-bold">Appt?</label>
                    <input type="checkbox" id="retiredInd" name="deliveryHasAppointment" style="margin:10px;transform: scale(1.5);" [(ngModel)]="crossBorderLoad.deliveryHasAppointment" disabled />
                </div>
            </div>
            <div class="row">
                <div class="col m-2 text-end">
                    <!--<button class="btn btn-primary m-2" (click)="save()">Save</button>-->
                    <!--<button type="button" class="btn btn-sml btn-secondary m-1" title="Complete Stops" tabindex="-1" (click)="completeStops()" *ngIf="isRequiredFilesComplete"><i class="fas fa-tasks"></i></button>-->
                    <!--<button type="button" class="btn btn-sml btn-success m-1" title="Complete Stops" tabindex="-1" (click)="completeStops()" *ngIf="isRequiredFilesComplete">Complete All Stops</button>-->
                    <button type="button" (click)="cancel()" class="btn btn-secondary m-2">Close</button>
                </div>
            </div>
        </div>
    </div>
</kendo-expansionpanel>

<kendo-expansionpanel [title]="'Documents'"
                      [subtitle]="''"
                      [expanded]="true">
    <div class="row">
        <div class="col" *ngIf="!isAdd">
            <button type="button" class="btn btn-primary" (click)="addDocument()">Add Document</button>
        </div>
        <div class="col-sm-6" *ngIf="isAdd">
            <label class="fw-bold">Document Type</label>
            <select name="documentType" [(ngModel)]="newDocumentTypeID" class="form-select" required>
                <option *ngFor="let docType of documentTypeList" value="{{docType.documentTypeID}}">{{docType.documentTypeName}}</option>
            </select>
        </div>
        <div class="col" *ngIf="isAdd && newDocumentTypeID > 0">
            <input type="file" id="file{{newDocumentTypeID}}" (change)="uploadFile($event, newDocumentTypeID)" />
            <button type="button" class="btn btn-secondary" (click)="cancelAddDocument()">Cancel</button>
        </div>
    </div>
    <div class="row">
        <div [ngClass]="isBatch ? 'col-sm-9' : 'col-sm-12'">
            <kendo-grid #crossBorderFilesGrid
                        [data]="gridData"
                        [sortable]="false"
                        [pageable]="false"
                        [filterable]="false"
                        [resizable]="isBatch">
                <kendo-grid-column field="documentTypeID" title="Action" width="140">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div style="white-space:nowrap;">
                            <a [routerLink]="" class="text-primary" (click)="viewFile(dataItem)" *ngIf="dataItem.blobFileID > 0"><i class="fas fa-eye fa-lg p-1"></i></a>
                            <a [routerLink]="" class="text-primary" (click)="downloadFile(dataItem)" *ngIf="dataItem.blobFileID > 0"><i class="fas fa-download fa-lg p-1"></i></a>
                            <a [routerLink]="" class="text-danger" (click)="deleteFile(dataItem)" *ngIf="canDeleteFile(dataItem)"><i class="fas fa-times fa-lg p-1"></i></a>
                            <label for="file{{dataItem.documentTypeID}}" *ngIf="dataItem.blobFileID == 0" style="cursor:pointer"><i class="fas fa-cloud-upload-alt fa-lg p-1"></i></label>
                            <form style="display:none;"><input type="file" id="file{{dataItem.documentTypeID}}" (change)="uploadFile($event, dataItem.documentTypeID)" /></form>
                            <button type="button" class="btn btn-sml btn-success m-1" title="Edit" tabindex="-1" (click)="editBatch(dataItem)" *ngIf="dataItem.documentTypeAbbrev == 'Combined' && dataItem.blobFileID > 0"><i class="fas fa-pencil-alt"></i></button>
                        </div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="documentTypeName" title="Document Type"></kendo-grid-column>
                <kendo-grid-column field="isRequired" title="Required?" width="100">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <input type="checkbox" [checked]="dataItem.isRequired" style="cursor: pointer;margin: 10px; transform: scale(1.5);" disabled />
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="fileName" title="File"></kendo-grid-column>
                <kendo-grid-column field="fileDescription" title="Description"></kendo-grid-column>
            </kendo-grid>
        </div>
        <div class="col-sm-3" *ngIf="isBatch">
            <div class="row">
                <div class="col">
                    <button type="button" class="btn btn-secondary float-end" (click)="closeEditBatch()"><i class="fas fa-times"></i></button>
                </div>
            </div>
            <div class="row" *ngFor="let docType of documentTypeList;let idx = index;">
                <div class="col">
                    <div *ngIf="docType.documentTypeAbbrev != 'Combined'">
                        <input type="checkbox"
                               id="docType{{docType.documentTypeID}}"
                               name="docType{{docType.documentTypeID}}"
                               style="transform: scale(1.5); margin: 5px;"
                               (change)="saveBlobFileBatch(docType, $event)"
                               [checked]="isBlobFileBatchChecked(docType)"
                               required />
                        <label for="docType{{docType.documentTypeID}}">{{docType.documentTypeName}}</label>
                        <!--[(ngModel)]="blobFileBatchList[idx].blobFileID > 0"-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</kendo-expansionpanel>

<kendo-expansionpanel [title]="'Load Stops'"
                      [subtitle]="''"
                      [expanded]="true">
    <div class="row">
        <div class="col">
            <order-stop-grid [quoteOrderLineID]="crossBorderLoad.quoteOrderLineID"
                             [pageType]="'crossborder'" [pageable]="false" [pageSize]="'all'"></order-stop-grid>
        </div>
    </div>
</kendo-expansionpanel>

<kendo-expansionpanel [title]="'Check Calls'"
                      [subtitle]="''"
                      [expanded]="true">
    <div class="row">
        <div class="col">
            <check-call-grid [quoteOrderLineID]="crossBorderLoad.quoteOrderLineID"
                             [viewType]="'tracking'"
                             [refreshDate]="checkCallRefreshDate">
            </check-call-grid>
        </div>
    </div>
</kendo-expansionpanel>

<document-viewer [fileName]="docViewerFileName" [fileUri]="docViewerFileUri" (onClose)="viewFile({})"></document-viewer>
